// src/common/services/external-services.api.ts
import { IExternalServices } from "@/types/external-services.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { getCompanyId } from "./company.api";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = `${import.meta.env.VITE_API_URL}/external-services`;
const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function createExternalServices(
  data: IExternalServices,
  files?: FileList
): Promise<ApiResponseType<IExternalServices>> {
  const url = `${API_URL}/`;

  const formData = new FormData();

  formData.append("data", JSON.stringify(data));

  // Adiciona os arquivos, se existirem
  if (files && files.length > 0) {
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]); // mesmo campo para múltiplos arquivos
    }
  }

  const options: RequestInit = {
    method: "POST",
    body: formData
  };

  const resp = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IExternalServices>
  >;

  return resp;
}

export const getExternalServices = async ({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = "10",
  orderBy = "-createdAt",
  fields = "_id, date, description, licensePlate, totalValue, requestorName, supplierName, status,companyId, createdAt",
  companyId, // <- agora recebe externamente
}: {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: string;
  orderBy?: string;
  fields?: string;
  companyId?: string;
}) => {
  const finalCompanyId = companyId || getCompanyId(); // fallback

  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
    companyId: finalCompanyId,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IExternalServices[]
  > & { totalItems: number };
  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
};

export async function deleteExternalServices(id: string) {
  const url = `${API_URL}/${id}`;
  const options: RequestInit = { method: "DELETE" };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IExternalServices>
  >;
}

export async function updateExternalServices(
  id: string,
  data: Partial<IExternalServices>
): Promise<ApiResponseType<IExternalServices>> {
  const url = `${API_URL}/${id}`;
  const options: RequestInit = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IExternalServices>
  >;
}

export async function changeStatusExternalServices(
  id: string
): Promise<ApiResponseType<IExternalServices>> {
  const url = `${API_URL}/change-status/${id}`;
  const options: RequestInit = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IExternalServices>
  >;
}
